import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//components
import { VendSizeDropdownComponent }         from '../../components/DomainData/VendSizeDropdown.component';
import { FlavorDropdownComponent }         from '../../components/DomainData/FlavorDropdown.component';

//baseclasses
import { BaseEditComponent }         from '../../baseclasses/BaseEdit.component';

@Component({
  selector: 'my-vendsizeflavorxref-edit',
  templateUrl: './VendSizeFlavorXrefEdit.component.html',
  providers: [{provide: BaseEditComponent, useExisting: forwardRef(() => VendSizeFlavorXrefEditComponent)}]
})
export class VendSizeFlavorXrefEditComponent extends BaseEditComponent {

    public displayDialog: boolean;

    form: FormGroup;

    @ViewChild(VendSizeDropdownComponent) public vendSizeDropdown: VendSizeDropdownComponent;
    @ViewChild(FlavorDropdownComponent) public flavorDropdown: FlavorDropdownComponent;
    
    @Input() public record: ent.VendSizeFlavorXref;

    @Output() onOK = new EventEmitter();

    constructor(fb: FormBuilder) 
    { 
        super();
        let group = {
          'name' : '',
          'vendSize' : '',
          'flavor' : '',
          'materialNumber' : '',
          'materialDescription' : '',
          'inactive' : ''
        };
        
        this.form = fb.group(group);
        

    }


    ngOnInit(): void {
        
    }

    onHide(){
        this.displayDialog = false;
    }

    onOKClick(event: any){
        
        this.onOK.emit();
        this.displayDialog = false;

    }

    vendSizeChange(event: any){
        
        this.record.VendSizeID = event;
    }

    flavorChange(event: any){
        
        this.record.FlavorID = event;
    }
}